export default __webpack_public_path__ + "static/media/243.98001ae9.jpg";